import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as glExpenses from '../../../../gl-expenses'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Where was it paid from?',
    isOptional: false,
    name: 'Associated GL Expense',
    partialId: PartialId.Standard.create('gl'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        glExpenses.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
